const configKey = process.env.REACT_APP_CONFIG;
const config = require(`./configs/${configKey}.json`);

if (!config) {
    throw new Error(`REACT_APP_CONFIG="${configKey}" is not valid.`);
}

export default config;
